import { getHandleResponse } from "helpers/getHandleResponse";
import { getAuthHeader } from "helpers/getAuthHeader";

const API_BASE_URL = process.env.REACT_APP_URL;

const makeRequest = async (endpoint, method, data = null) => {
    const requestOptions = {
        method,
        headers: getAuthHeader(),
    };

    if (data) {
        requestOptions.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        const result = await getHandleResponse(response);
        return { error: false, data: result };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const buildQueryString = (params) => {
    const filteredParams = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    return new URLSearchParams(filteredParams).toString();
};

const catalogService = {
    // ============ CENTROS DE COSTO ============
    getCostCenters: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/catalog/cost-centers${queryString ? `?${queryString}` : ''}`, "GET");
    },

    createCostCenter: (data) => makeRequest("/api/catalog/cost-centers", "POST", data),

    updateCostCenter: (id, data) => makeRequest(`/api/catalog/cost-centers/${id}`, "PUT", data),

    // ============ TIPOS DE GASTO ============
    getExpenseTypes: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/catalog/expense-types${queryString ? `?${queryString}` : ''}`, "GET");
    },

    createExpenseType: (data) => makeRequest("/api/catalog/expense-types", "POST", data),

    updateExpenseType: (id, data) => makeRequest(`/api/catalog/expense-types/${id}`, "PUT", data),

    // ============ NOTIFICACIONES ============
    getNotifications: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/catalog/notifications${queryString ? `?${queryString}` : ''}`, "GET");
    },

    markNotificationAsRead: (id) => makeRequest(`/api/catalog/notifications/${id}/read`, "PATCH"),

    markAllNotificationsAsRead: () => makeRequest("/api/catalog/notifications/read-all", "POST"),

    // ============ USUARIOS ============
    getUsers: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/catalog/users${queryString ? `?${queryString}` : ''}`, "GET");
    },

    createUser: (data) => makeRequest("/api/catalog/users", "POST", data),

    updateUser: (id, data) => makeRequest(`/api/catalog/users/${id}`, "PUT", data),

    deleteUser: (id) => makeRequest(`/api/catalog/users/${id}`, "DELETE"),
};

export default catalogService;